import { defineMessages } from 'react-intl'

export default defineMessages({
  // Name to show for an observation when it does not match any preset
  defaultObservationName: 'Observation'
})
